module.exports = "var hello = \"World\""